erpnext.ProductGrid = class {
    /* Options:
        - items: Items
        - settings: E Commerce Settings
        - products_section: Products Wrapper
        - preference: If preference is not grid view, render but hide
    */

    constructor(options) {
        Object.assign(this, options);
        if (this.preference !== "Grid View") {
            this.products_section.addClass("hidden");
        }
        this.products_section.empty();
        this.make();

        // Bind the click event for .float-end here
        this.bind_click_events();
        this.initModal(); // Call modal initialization during grid initialization

        //  $(document).on('input', '.quantity-input', (event) => {
        //     this.updateItemsData();
        // });
    }

    // Utility Method to Update the itemsData Array Based on Current Input Values
    updateItemsData() {
        this.itemsData = []; // Ensure itemsData is a property of the class
        const quantityInputs = document.querySelectorAll(".quantity-input");

        quantityInputs.forEach((input) => {
            const itemCode = input.dataset.itemCode;
            const qty = parseInt(input.value, 10);

            if (qty > 0) {
                this.itemsData.push({
                    item_code: itemCode,
                    qty: qty
                });
            }
        });
    }

    make() {
        let me = this;
        let html = `<div class="row row-cols-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-0" id="FeaturedProducts">`;
        this.items.forEach((item, index) => {
            let title = item.web_item_name || item.item_name || item.item_code || "";
            title = title.length > 90 ? title.substr(0, 90) + "..." : title;
            html += `<div class="col my-2">
                        <div class="product-card clearfix">
                            <div class="product-card-img-box">`
            html += me.get_image_html(item, title);
            html += `   </div>
                            <div class="product-card-info text-center">`
            html += me.get_card_body_html(item, title, me.settings);
            html += `   </div>
                            <div class="product-action">
                                <div class="float-start"><a class="do-quick-order" href="/${item.route || '#'}">View Product</a></div>
                                <div class="float-end"><a class="do-quick-order" href="javascript:void(0);" data-id='${item.item_code}'>Quick Order</a></div>
                            </div>
                        </div>
                    </div>`;

            // Add a row break after every 5 cards, but not after the last item
            // if ((index + 1) % 5 === 0 && index !== this.items.length - 1) {
            //     html += `</div><div class="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-0">`;
            // }
        });
        html += `</div>`; // Close the last row div
        let $product_wrapper = this.products_section;
        $product_wrapper.html(html); // Use .html() to replace content instead of .append()
    }

    get_image_html(item, title) {
        let image = item.website_image;
        if (image) {
            return `
                <a href="/${item.route || '#'}" class="product-card-img">
                    <img class="img-fluid" src="${image}" alt="${title}">
                </a>
            `;
        } else {
            return `
                <a href="/${item.route || '#'}" class="product-card-img">
                    <img class="img-fluid" src="/files/no-image-icon.png" alt="No Image Available">
                </a>
            `;
        }
    }

    get_card_body_html(item, title, settings) {
        if (frappe.session.user == 'Guest') {
            let body_html = `
            <div class="text-center card-body-flex d-flex align-items-center justify-content-center p-2">
                ${this.get_title(item, title)}
                <div class="d-inline-block product-price-range" data-item-code="${item.item_code}"><a href="/login" class="px-2" style="color: red;border-left: 4px solid red;background-color: #efefef;">Login To Buy</a></div>
                ${this.get_stock_availability(item, settings)}
                ${item.in_stock ? this.get_primary_button(item, settings) : ''}
            </div>
        `;
            return body_html;
        } else {
            let body_html = `
                ${this.get_title(item, title)}
                <div class="price-text product-price- product-price-range" data-item-code="${item.item_code}"></div>
                ${this.get_stock_availability(item, settings)}
                ${item.in_stock ? this.get_primary_button(item, settings) : ''}
        `;
            this.get_price_html(item)
            // ${frappe.session.user !== 'Guest' ? this.get_price_html(item) : ''}
            return body_html;
        }
    }

    get_title(item, title) {
        return `
            <h4>
                <a href="/${item.route || '#'}">
                    ${title || ''}
                </a>
            </h4>
        `;
    }


    get_wishlist_icon(item) {
        let icon_class = item.wished ? "wished" : "not-wished";
        return `
            <div class="like-action ${item.wished ? "like-action-wished" : ''}"
                data-item-code="${item.item_code}">
                <svg class="icon sm">
                    <use class="${icon_class} wish-icon" href="#icon-heart"></use>
                </svg>
            </div>
        `;
    }

    get_cart_indicator(item) {
        return `
            <div class="cart-indicator ${item.in_cart ? '' : 'hidden'}" data-item-code="${item.item_code}">
                1
            </div>
        `;
    }

    get_price_html(item) {
        frappe.call({
            method: 'erpnext.e_commerce.api.get_item_data',
            args: {
                item_code: item.item_code,
                has_variants: item.has_variants
            },
            callback: function (response) {
                let data = response.message;

                if (data && data.min_price !== undefined && data.max_price !== undefined && data.min_price === data.max_price) {
                    document.querySelector(`.product-price-range[data-item-code='${item.item_code}']`).innerHTML = `$${data.min_price}`;
                } else {
                    if (data && data.min_price !== undefined && data.max_price !== undefined) {
                        let range = `$${data.min_price} - $${data.max_price}`;
                        document.querySelector(`.product-price-range[data-item-code='${item.item_code}']`).innerHTML = range;
                    } else if (data && data.price !== undefined) {
                        document.querySelector(`.product-price-range[data-item-code='${item.item_code}']`).innerHTML = `$${data.price}`;
                    }
                    else {
                        document.querySelector(`.product-price-range[data-item-code='${item.item_code}']`).innerHTML = '$0';
                    }
                }
            }
        });
    }




    get_stock_availability(item, settings) {
        if (settings.show_stock_availability) {
            if (item.on_backorder) {
                return `
                    <span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
                        ${__("Available on backorder")}
                    </span>
                `;
            } else if (!item.in_stock) {
                return `
                    <span class="out-of-stock mb-2 mt-1">
                        ${__("Out of stock")}
                    </span>
                `;
            }
        }
        return ``;
    }

    get_primary_button(item, settings) {
        if (item.has_variants) {
            return `
            <div id="${item.name}" class="btn
                    btn-sm btn-primary btn-add-to-cart-list
                    w-100 mt-2 ${item.in_cart ? 'Visible' : 'Visible'}"
                    data-item-code="${item.item_code}">
                    ${settings.enable_checkout ? __('Add to Cart') : __('Add to Quote')}
                </div>
        <a href="/cart">
                    <div id="${item.name}" class="btn
                        btn-sm btn-primary btn-add-to-cart-list
                        w-100 mt-2 go-to-cart-grid
                        ${item.in_cart ? 'Visible' : 'Visible'}"
                        data-item-code="${item.item_code}">
                        ${settings.enable_checkout ? __('Go to Cart') : __('Go to Quote')}
                    </div>
                </a>
            `;
        } else if (settings.enabled) {
            return `
                <div id="${item.name}" class="btn
                    btn-sm btn-primary btn-add-to-cart-list
                    w-100 mt-2 ${item.in_cart ? 'Visible' : 'Visible'}"
                    data-item-code="${item.item_code}">
                    ${settings.enable_checkout ? __('Add to Cart') : __('Add to Quote')}
                </div>
                <a href="/cart">
                    <div id="${item.name}" class="btn
                        btn-sm btn-primary btn-add-to-cart-list
                        w-100 mt-2 go-to-cart-grid
                        ${item.in_cart ? 'Visible' : 'Visible'}"
                        data-item-code="${item.item_code}">
                        ${settings.enable_checkout ? __('Go to Cart') : __('Go to Quote')}
                    </div>
                </a>
            `;
        } else {
            return ``;
        }
    }

    bind_click_events() {
        $(document).on('click', '.float-end .do-quick-order', function (e) {
            // var itemCode = $(this).find('a').data('id');
            var itemCode = $(this).data('id');
            var website_image = null;
            var modal = document.getElementById("quickOrderModal");
            var span = document.getElementsByClassName("close")[0];
            var user = frappe.session.user;
            modal.style.display = "block";

            span.onclick = function () {
                modal.style.display = "none";
            };

            window.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            };
            var website_image_response = "/files/no-image-icon.png";
            frappe.call({
                method: "erpnext.e_commerce.shopping_cart.cart.get_template_image",
                args: {
                    item_code: itemCode
                },
                callback: function (r) {
                    console.log("r.message : "+r.message);
                    if (r.message) {
                        website_image_response = r.message;
                    }
                }
            });
            console.log("website_image_response : "+website_image_response);
            frappe.call({
                method: "erpnext.e_commerce.shopping_cart.cart.get_variants",
                args: {
                    item_code: itemCode
                },
                callback: function (response) {
                    var variants = response.message;
                    $('.modal-body').html('');

                    var variantsHtml = '';

                    if (variants.length > 0) {
                        var firstVariant = variants[0];
                        var displayName = firstVariant.web_item_name.includes(' - ')
                            ? firstVariant.web_item_name.split('-').pop().trim()
                            : firstVariant.web_item_name;

                        variantsHtml += `
                            <div class="row align-items-center">
                                <div class="col-md-2 col-lg-2 col-sm-3 item-image">
                                    <img src="${website_image_response}" alt="" style="width: 100%; height: auto;">
                                </div>
                                <div class="col-md-10 col-lg-10 col-sm-9 item-name">
                                    <h4>${itemCode}</h4>
                                </div>
                            </div>
                            <div class="row mt-2 rowHeader desktop-prodcut">
                                <div class="col-md-1 col-lg-1 col-sm-3"><span style="padding-left: 5px;font-size: 20px;font-weight: bold;">Item</span></div>
                                <div class="col-md-4 col-lg-5 col-sm-4" style="padding-left: 25px;"><span style="font-size: 20px;font-weight: bold;">Name</span></div>
                                <div class="col-md-2 col-lg-1 col-sm-1"><span style="font-size: 20px;font-weight: bold;">Rate</span></div>
                                <div class="col-md-4 col-lg-4 col-sm-4 text-right"><span style="padding-right: 70px;font-size: 20px;font-weight: bold;">Qty</span></div>
                            </div>
                            <hr style="margin: 0 0 20px 0; border-top: 1px solid #ddd;">`;
                    }
                    // Remove below sort logic beacause implement in get_variants api 07-FEB-2025
                    // Sort the variants by total_available_qty in descending order
                    // variants.sort(function (a, b) {
                    //     return b.total_available_qty - a.total_available_qty;
                    // });

                    variants.forEach(function (variant) {
                        var displayName = variant.web_item_name.includes(' - ')
                            ? variant.web_item_name.split('-').pop().trim()
                            : variant.web_item_name;


                            variantsHtml += `<div class="row" data-fieldname="${variant.item_code}">
                            <div class="col-12">
                                <div class="mobile-prodcut-list">
                                    <div class="mobile-product-img">
                                        <img src="${variant.website_image ? variant.website_image : '/files/no-image-icon.png'}">
                                    </div>
                                    <div class="mobile-product-detials">
                                        <h5>${displayName}</h5>
                                        <p class="mb-0">${displayName}</p>`;
                                        if (user != 'Guest') {
                            variantsHtml += `                       
                                                      <p>$${variant.price_rate}</p>`;
                        } else {
                            variantsHtml += `<p><a href="/login" class="px-2 popUp-login" style="color: red;border-left: 4px solid red;background-color: #efefef;">Login</a></p>`;
                        }
                            variantsHtml += `
                                        <div class="quantity-container">
                                                      <div class="d-flex cart-input-box">
                                                          <span class="input-group-prepend d-sm-inline-block">
                                                              <button class="quantity-left-minus badge cart-btn" data-dir="dwn">
                                                                  -
                                                              </button>
                                                          </span>
                                                          <input type="number" id="${variant.item_code}" class="quantity-input text-center cart-qty border" value="0" data-item-code="${variant.item_code}">
                                                          <span class="input-group-append d-sm-inline-block">
                                                              <button class="quantity-right-plus badge cart-btn" data-dir="up">
                                                                  +
                                                              </button>
                                                          </span>
                                                          <svg class="trash-svg remove_item" data-item-code="${variant.item_code}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-left: 10px;">
                                                              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H2.5zm3 4a.5.5 0 0 1 1 0v7.5a.5.5 0 0 1-1 0V5zm3 0a.5.5 0 0 1 1 0v7.5a.5.5 0 0 1-1 0V5z"></path>
                                                          </svg>
                                                      </div>
                                                  </div>
                                    </div>
                                </div>
                            </div>
                          </div>`;


                          variantsHtml += `
                      <div class="row desktop-prodcut" data-fieldname="${variant.item_code}">
                          <div class="col-sm-12">
                              <div class="pro-details-list-con">
                                  <div class="pro-details-list-col">
                                      <div class="row modelRow row-data">
                                          <div class="col-md-2 col-lg-1 col-sm-2 item-image popUp-image">
                                              <div class="variant-image">
                                                  <img src="${variant.website_image ? variant.website_image : '/files/no-image-icon.png'}" alt="" style="width: 100%; height: auto;">
                                              </div>
                                          </div>
                                          <div class="col-md-5 col-lg-5 col-sm-5 info-col popUp-name" style="padding-left:25px">
                                              <div class="variant-info" style="margin: 0;">
                                                  <p>${displayName}</p>
                                              </div>
                                          </div>
                                          
                                          <div class="col-md-2 col-lg-1 col-sm-2 info-col popUp-price" style="padding-right:60px; padding-top:15px">
                                              <div class="variant-price">`;
                    if (user != 'Guest') {
                        variantsHtml += `                       
                                                  <p>$${variant.price_rate}</p>`;
                    } else {
                        variantsHtml += `<p><a href="/login" class="px-2 popUp-login" style="color: red;border-left: 4px solid red;background-color: #efefef;">Login</a></p>`;
                    }


                    variantsHtml += `
                                              </div>
                                          </div>
                                          <div class="col-md-3 col-lg-4 col-sm-3 item-button popUp-quantity">
                                              <div class="quantity-container">
                                                  <div class="d-flex cart-input-box">
                                                      <span class="input-group-prepend d-sm-inline-block">
                                                          <button class="quantity-left-minus badge cart-btn" data-dir="dwn">
                                                              -
                                                          </button>
                                                      </span>
                                                      <input type="number" id="${variant.item_code}" class="quantity-input text-center cart-qty border" value="0" data-item-code="${variant.item_code}">
                                                      <span class="input-group-append d-sm-inline-block">
                                                          <button class="quantity-right-plus badge cart-btn" data-dir="up">
                                                              +
                                                          </button>
                                                      </span>
                                                      <svg class="trash-svg remove_item" data-item-code="${variant.item_code}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16" style="margin-left: 10px;">
                                                          <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H2.5zm3 4a.5.5 0 0 1 1 0v7.5a.5.5 0 0 1-1 0V5zm3 0a.5.5 0 0 1 1 0v7.5a.5.5 0 0 1-1 0V5z"></path>
                                                      </svg>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>`;

                        // variantsHtml += `
                        //     <div class="row" data-fieldname="${variant.item_code}">
                        //         <div class="col-sm-12">
                        //             <div class="pro-details-list-con">
                        //                 <div class="pro-details-list-col">
                        //                     <div class="row">
                        //                         <div class="col-md-1 col-lg-1 col-sm-3 item-image">
                        //                             <div class="variant-image">
                        //                                 <img src="${variant.website_image ? variant.website_image : '/files/no-image-icon.png'}" alt="" class="card-detail-img">
                        //                             </div>
                        //                         </div>
                        //                         <div class="col-md-4 col-lg-5 col-sm-4 info-col" style="padding-left:25px">
                        //                             <div class="variant-info" style="margin: 0;">
                        //                                 <p>${displayName}</p>
                        //                             </div>
                        //                         </div>
                        //                         <div class="col-md-2 col-lg-1 col-sm-1 info-col" style="padding-right:60px; padding-top:15px">
                        //                             <div class="variant-price">`;
                        // if (user != 'Guest') {
                        //     variantsHtml += `<p>$${variant.price_rate}</p>`;
                        // } else {
                        //     variantsHtml += `<p><a href="/login" class="px-2" style="color: red;border-left: 4px solid red;background-color: #efefef;">Login</a></p>`;
                        // }
                        // variantsHtml += `
                        //                     </div>
                        //                         </div>
                        //                         <div class="col-md-4 col-lg-4 col-sm-4 item-button">
                        //                             <div class="quantity-container">
                        //                                 <div class="d-flex cart-input-box">
                        //                                     <span class="input-group-prepend d-sm-inline-block">
                        //                                         <button class="quantity-left-minus badge cart-btn" data-dir="dwn">
                        //                                             -
                        //                                         </button>
                        //                                     </span>
                        //                                     <input id="${variant.item_code}" class="quantity-input text-center cart-qty border qty-check" value="0" data-item-code="${variant.item_code}">
                        //                                     <span class="input-group-append d-sm-inline-block">
                        //                                         <button class="quantity-right-plus badge cart-btn" data-dir="up">
                        //                                             +
                        //                                         </button>
                        //                                     </span>
                        //                                     <svg class="trash-svg remove_item" data-item-code="${variant.item_code}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16" style="margin-left: 10px;">
                        //                                         <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H2.5zm3 4a.5.5 0 0 1 1 0v7.5a.5.5 0 0 1-1 0V5zm3 0a.5.5 0 0 1 1 0v7.5a.5.5 0 0 1-1 0V5z"></path>
                        //                                     </svg>
                        //                                 </div>
                        //                             </div>
                        //                         </div>
                        //                     </div>
                        //                 </div>
                        //             </div>
                        //         </div>
                        //     </div>`;
                    });

                    // Add the buttons below the rows
                    variantsHtml +=
                        `<div class="row" style="margin-top: 20px;">
                        <div class="col-md-1 col-lg-1 col-sm-3 item-image"></div>
                        <div class="col-md-4 col-lg-5 col-sm-4 info-col" style="padding-left:25px"></div>
                        <div class="col-md-2 col-lg-1 col-sm-1 info-col" style="padding-right:60px; padding-top:15px"></div>
                        `;
                    if (user != 'Guest') {
                        variantsHtml += `<div class="col-md-4 col-lg-4 col-sm-4 action-button">
                            <button class="btn btn-primary add-to-cart">Add to Cart</button>
                            <button class="btn btn-outline-primary remove-all">Remove All</button>
                        </div>
                    </div>`;
                    } else {
                        variantsHtml += `<div class="col-md-4 col-lg-4 col-sm-4 item-button">
                                <a class="btn btn-primary" href='/login'>Login</a>
                            </div>
                        </div>`;
                    }


                    $('.modal-body').append(variantsHtml);

                    if (user != 'Guest') {
                        var rows = document.querySelectorAll('.row[data-fieldname]');
                        rows.forEach(function (row) {
                            var itemCode = row.getAttribute('data-fieldname');

                            frappe.call({
                                method: "erpnext.e_commerce.shopping_cart.cart.get_product_info",
                                args: {
                                    "item_code": itemCode,
                                },
                                callback: function (response) {
                                    var qty = response.message[itemCode];

                                    // Check if the qty is 0
                                    if (qty <= 0) {
                                        // Apply blur effect and reduce opacity directly via inline styles
                                        row.style.filter = 'grayscale(1)';
                                        row.style.opacity = '0.6';
                                        row.style.pointerEvents = 'none'; // Disable interaction

                                        // Disable interaction for only input elements within the row
                                        var inputs = row.querySelectorAll('input');
                                        inputs.forEach(function (input) {
                                            input.disabled = true; // Disable the input fields
                                        });
                                    }
                                }
                            });
                        });
                    }
                }
            });

            if (user != 'Guest') {
                frappe.call({
                    method: "erpnext.e_commerce.shopping_cart.cart.get_qty",
                    callback: function (response) {

                        var itemsData = response.message; // Data from the backend
                        var quantityInputs = document.querySelectorAll(".quantity-input");

                        if (Object.keys(itemsData).length === 0) {
                            // If there are no items in the cart, set all quantities to 0
                            quantityInputs.forEach(function (input) {
                                input.value = 0;
                            });
                        } else {
                            // If items are present, update the quantities accordingly
                            quantityInputs.forEach(function (input) {
                                var itemCode = input.dataset.itemCode; // Get the item code from the input's data attribute

                                if (itemsData[itemCode] !== undefined) {
                                    // Set the quantity based on the response
                                    input.value = itemsData[itemCode];
                                } else {
                                    // If the item is not in the response, set the quantity to 0
                                    input.value = 0;
                                }
                            });
                        }
                    }
                });
            }
        });
    }



    // Method to initialize and inject modal styles and HTML
    initModal() {
        // Add modal styles dynamically
        const modalStyles = `
            .modal {
              display: none;
              position: fixed;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              overflow: auto;
              background-color: rgb(0,0,0);
              background-color: rgba(0,0,0,0.4);
            }
            .close {
              color: #aaa;
              float: right;
              font-size: 28px;
              font-weight: bold;
            }
            .close:hover, .close:focus {
              color: black;
              text-decoration: none;
              cursor: pointer;
            }
        `;

        // Inject the styles into the document
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = modalStyles;
        document.head.appendChild(styleSheet);

        // Add modal HTML structure dynamically
        const modalHtml = `
            <div id="quickOrderModal" class="modal">
                <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content shadow">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLongTitle">Quick Order</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Inject the modal HTML into the body
        document.body.insertAdjacentHTML('beforeend', modalHtml);

        // Initialize modal functionality
        // this.initModalEvents();
    }

};
